import { render, staticRenderFns } from "./message-container-skeleton.vue?vue&type=template&id=64c0435a"
import script from "./message-container-skeleton.vue?vue&type=script&lang=js"
export * from "./message-container-skeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports